<template lang="pug">
  .obj-list.obj-list_camps
    .obj-list__item(
      v-for="camp in campsData"
    )
      .obj.obj_horizontal
        .obj__media
          image-slider(
          :data-images="camp.slider_preview"
          )
        router-link.obj__body(
          :to="`/pages/camps/${camp.id}/`"
        )
          .obj__title {{ camp.name }}
          <!--.obj__rating-->
            <!--rating(-->
              <!--:value="camp.rating"-->
            <!--)-->
          .obj__description(
            v-bind:title='camp.address'
          ) {{ camp.address.region }}, {{ camp.address.area }}
          <!--.obj__date Сезон: {{ shiftSeasons[camp.season] }}-->
</template>

<script>
import ImageSlider from "@/components/imageSlider/ImageSlider.vue";
import Rating from "@/components/rating/Rating.vue";

export default {
  name: "OtherCamps",
  components: {
    ImageSlider,
    Rating
  },
  props: {
    campsData: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    shiftSeasons() {
      return this.$store.getters.shiftSeasons();
    }
  }
};
</script>
